import React, { Component } from "react";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import TestAccordion from "./TestAccordion";
import { 
  auth,
  getUserDetails,
  getOrdersAPI,
  updateOrder,
  ordersToCSV,
  logout
 } from "./utils/api";

import CreditHoldBanner from "./CreditHoldBanner";
import Header from "./Header";
import Login from "./Login";
import Orders from "./Orders";
import Footer from "./Footer";
import { connect } from "react-redux";
import {
  setCustomersWeb,
  setCompanyId,
  setCompanyIds,
  setLocations,
  setPeople,
  resetState,
  setOrders,
  setProductData,
  setAllUserDetails,
  setAccount,
  setUserDetails,
} from "./redux/reducers/app";

const mapStateToProps = (state) => {
  return {
    companyId: state.app.companyId,
    account: state.app.account,
    locations: state.app.locations,
    productData: state.app.productData,
    orders: state.app.orders,
    customersWeb: state.app.customersWeb,
    Flag_CreditHold: state.app.Flag_CreditHold
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCustomers: (customers) => dispatch(setCustomersWeb(customers)),
    setCompanyId: (id) => dispatch(setCompanyId(id)),
    setCompanyIds: (ids) => dispatch(setCompanyIds(ids)),
    setLocations: (locations) => dispatch(setLocations(locations)),
    setUserDetails: (data) => dispatch(setUserDetails(data)),
    setPeople: (people) => dispatch(setPeople(people)),
    setAccount: (account) => dispatch(setAccount(account)),
    setOrders: (orders) => dispatch(setOrders(orders)),
    setProductData: (data) => dispatch(setProductData(data)),
    setAllUserDetails: (data) => dispatch(setAllUserDetails(data)),
    resetState: () => dispatch(resetState()),
  };
};

class App extends Component {
  constructor() {
    super();

    //bind methods here...
    this.appAuth = this.appAuth.bind(this);
    this.getUserDetails = this.getUserDetails.bind(this);
    this.getOrdersNew = this.getOrdersNew.bind(this);
    this.clearOrders = this.clearOrders.bind(this);
    this.exportOrders = this.exportOrders.bind(this);
    this.updateOrder = this.updateOrder.bind(this);
    this.appFirstLogin = this.appFirstLogin.bind(this);
    this.appLogout = this.appLogout.bind(this);

    // Initial state
    this.state = {
      loginMessage: "",
      isRefreshing: false,
      hasShownLogoutToast: false  // Add this flag
    };
  }

  componentDidMount() {
    if (this.isLoggedIn()) {
      this.refreshUserData();
    }
  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps, prevState) {
    //watch for changes to company id
    if (
      this.props.productData &&
      Array.isArray(this.props.productData.Customers) &&
      this.props.productData.Customers.length > 0 &&
      this.props.companyId
    ) {
      if (this.props.companyId !== prevProps.companyId) {
        const newCompanyId = this.props.companyId;
        const newCompany = this.props.customersWeb.find(
          (el) => el.__pk_Record_UUID === this.props.companyId
        );
        const LogoURL = "data:image/png;base64," + newCompany.logoBase64; 
        this.props.setUserDetails({
            companyId: newCompany.__pk_Record_UUID,
            companyName: newCompany.Customer_Name,
            locations: newCompany.Locations,
            companyLogoURL: LogoURL,
            Carrier_Organised_By_Default: newCompany.Carrier_Organised_By_Default,
            Delivery_Point_Default: newCompany.Delivery_Point_Default,
            Flag_CreditHold: newCompany.Flag_CreditHold,
            viewOnly: newCompany.viewOnly,
            canExport: newCompany.canExport,
            peopleOnsite: newCompany.OnSite || []
          })
      }
    }
  }

  appAuth(accountname, password) {
    return auth(accountname, password)
      .then((response) => {
        if (!response.ok || !response.accessToken || !response.user) {
          this.setState({ loginMessage: response.statusText || 'Unable to login. Please check your internet connection, and contact SAMI support if the issue persists.'});
          return response.statusText;
        } else {
          // Update the token and expiry in state
          const account = { ...this.props.account };
          toast.dismiss();
          account.userEmailAddress = response.user.email;
          account.id = response.user.id;
          account.token = response.accessToken;

          this.props.setAccount(account);
          this.setState({ loginMessage: "Please, wait..." });
          return "ok";
        }
      });
  }

  // Helper method to show session expired toast (only once)
  showSessionExpiredToast = () => {
    if (!this.state.hasShownLogoutToast && this.isLoggedIn()) {
      this.setState({ hasShownLogoutToast: true });
      toast.dismiss();
      toast.error('Your session has expired. Please log in again.');
    }
  }

  refreshUserData = async () => {
    // Don't block the UI
    this.setState({ isRefreshing: true });

    try {
      const userDetails = await this.getUserDetails();
      
      if (userDetails !== "ok") {
        console.error('Failed to refresh user data:', userDetails);
        this.showSessionExpiredToast();
        await this.appLogout();
        return;
      } else {
        toast.dismiss();
      }

    } catch (error) {
      console.error('Error refreshing user data:', error);
      // If it's an auth error, logout
      if (error.status === 401 || error.status === 403) {
        this.showSessionExpiredToast();
        await this.appLogout();
      } else {
        // For other errors, maybe just notify the user
        toast.warn('Unable to refresh some data. Some information might be outdated.');
      }
    } finally {
      this.setState({ isRefreshing: false });
    }
  };

  isLoggedIn() {
    const { account } = this.props;
    return (
      account &&
      Object.keys(account).length > 0 &&
      account.token !== null &&
      account.id !== null
    );
    
  }

  getUserDetails() {
    //find People record with matching email address
    return getUserDetails()
      .then((body) => {
        if (body === "Web access has not been granted") {
          this.setState({
            loginMessage: "Web access is not enabled for this customer account",
          });
          return;
        } else {
          if (!body.fieldData) {
            return "fail";
          }
          const account = { ...this.props.account };
          let currentCompanyId = this.props.companyId;
          let productData = JSON.parse(
            body.fieldData.Web_Customer_Products_JSON_c
          );

          //get the data for all companies all together
          let webCompanies = JSON.parse(body.fieldData.Web_Companies_JSON_c);
          
          let companyData = productData.Customers.find(
            (el) => el.__pk_Record_UUID === currentCompanyId
          );
          
          if (!companyData) {
            companyData = productData.Customers.find(
              (el) => el.__pk_Record_UUID === webCompanies[0].id
            );
          }

          let productCompanies = productData.Customers;

          //add the OnSite data to the product companies
          let allCompanies = [];
          webCompanies.forEach((company, index) => {
            //find the matching company id where company.id === productCompanies.__pk_Record_UUID
            const matchingProductCompany = productCompanies.find(
              (productCompany) => productCompany.__pk_Record_UUID === company.id
            );
            const record = {
              ...matchingProductCompany,
              OnSite: company.OnSite,
              logoBase64: company.logoBase64,
              Carrier_Organised_By_Default: company.Carrier_Organised_By_Default,
              Delivery_Point_Default: company.Delivery_Point_Default,
              Flag_CreditHold: company.Flag_CreditHold,
              canExport: company.canExport,
              viewOnly: company.viewOnly
            }
            allCompanies.push(record);

            //fill the companyData if the company.id === companyData.__pk_Record_UUID
            if (company.id === companyData.__pk_Record_UUID) {
              companyData.name = company.name;
              companyData.OnSite = company.OnSite;
              companyData.logoBase64 = company.logoBase64;
              companyData.Carrier_Organised_By_Default = company.Carrier_Organised_By_Default;
              companyData.Delivery_Point_Default = company.Delivery_Point_Default;
              companyData.Flag_CreditHold = company.Flag_CreditHold;
              companyData.viewOnly = company.viewOnly;
              companyData.canExport = company.canExport;
            }
          });
          account.userId = body.fieldData.__pk_Record_UUID;
          account.userFullName = body.fieldData.Name_Full_c;
          account.companyIds = webCompanies;
          account.companyName = companyData.name;
          account.viewOnly = companyData.viewOnly;
          account.canExport = companyData.canExport;
          account.companyLogoURL = "data:image/png;base64," + companyData.logoBase64;
          account.deliveryPoint = companyData.Delivery_Point_Default;
          account.carrierPref = companyData.Carrier_Organised_By_Default;
          account.Flag_CreditHold = companyData.Flag_CreditHold;
          account.peopleOnsite = companyData.OnSite;

          this.props.setAllUserDetails({
            account,
            productData,
            companyId: companyData.__pk_Record_UUID,
            companyIds: account.companyIds,
            locations: companyData.Locations,
            customersWeb: allCompanies,
            viewOnly: companyData.viewOnly,
            canExport: companyData.canExport,
            Flag_CreditHold: companyData.Flag_CreditHold,
            people: companyData.OnSite || []
          })
          return "ok";
        }
      })
      .catch((error) => {
        console.error('Error getting user details:', error);
        this.setState({
          loginMessage: "Server Error. Contact SAMI for support.",
        });
      });
  }
  
  async clearOrders(){
    this.props.setOrders([]);
  }
  
  async getOrdersNew(
    limit,
    searchString,
    offset,
    filterStatuses,
    dateRange,
    dateField,
    sortBy,
    add
  ) {
    const statusArray = () => {
      if (!filterStatuses) {
        return (filterStatuses = [""]);
      }
      const keys = Object.keys(filterStatuses);
      const active = keys.filter(function (id) {
        return filterStatuses[id];
      });
      return active;
    };
    
    try {
      const body = await getOrdersAPI(
        limit,
        searchString,
        offset,
        statusArray(),
        dateRange,
        dateField,
        sortBy,
        this.props.companyId
      );
      
      // Add the orders to the existing list, otherwise replace list
      if (add) {
        const orders = this.props.orders;
        const moreOrders = orders.concat(body);
        this.props.setOrders(moreOrders);
        return "ok";
      } else {
        this.props.setOrders(body);
        return "ok";
      }
    } catch (error) {
      console.error("Error in getOrdersAPI:", error);
      
      // Check if it's an authentication error
      if (error.status === 401 || error.status === 403) {
        this.showSessionExpiredToast();
        await this.appLogout();
        return "auth_error";
      } else {
        // For other errors, notify the user
        toast.error('Unable to load orders. Please try again.');
        return "error";
      }
    }
  }

  exportOrders = async(
    searchString,
    offset,
    limit,
    filterStatuses,
    dateRange,
    dateField,
    sortBy,
    companyId
  ) => {
    const toastId = toast.info(
      "⏱ Exporting Order List...",
      {
        autoClose: false,
        pauseOnFocusLoss: false,
      }
    );
    
    const statusArray = () => {
      if (!filterStatuses) {
        return (filterStatuses = [""]);
      }
      const keys = Object.keys(filterStatuses);
      const active = keys.filter(function (id) {
        return filterStatuses[id];
      });
      return active;
    };
    
    await ordersToCSV(
      searchString,
      offset,
      limit,
      statusArray(),
      dateRange,
      dateField,
      sortBy,
      companyId
    )
    .then((body) => {
        toast.dismiss(toastId);
      })
      .catch((res) => {
        console.log(res.error);
        toast.update(toastId, {
          render: "Order List Export failed!",
          type: "error",
          autoClose: 3000,
        });
      });
  }

  appFirstLogin = async (accountname, password) => {
    localStorage.clear();
    if (this.state.loginMessage !== "Please, wait...") {
      this.setState({ loginMessage: "Please, wait..." });
      const login = await this.appAuth(accountname, password);
      if (login === "ok") {
        const userDetails = await this.getUserDetails();
      }
    }
  };

  updateOrder = async (mode, recordId, data) => {
    if (!data || !mode) {
      return;
    }

    if (mode === "edit") {
      return updateOrder(recordId, data)
        .then((body) => {
          this.props.setOrders(body);
        })
        .catch((res) => {
          //console.log(res.error);
        });
    } else if (mode === "new") {
      return createOrder(data)
        .then((body) => {
          return body;
        })
        .catch((res) => {
          console.log("Error creating order: " + res.error);
        });
    }
  };

  downloadDA(recordId) {
    if (!recordId) {
      //console.log('missing web download recordId');
      return;
    }

    return createDADownload(recordId)
      .then((body) => {
        //console.log(body);
        return body.response.scriptResult.prerequest;
      })
      .catch((res) => {
        console.log("Error downloading DA: " + recordId, res.error);
      });
  }
  
  logEvent(orderNum, eventName) {
    if (!recordId) {
      return;
    }
    return postLogEvent(orderNum, eventName)
      .then((body) => {
        return 0;
      })
      .catch((res) => {
        console.log("Error Logging " + eventName + " event: " + recordId, res.error);
      });
  }

  appLogout = async () => {
    try {
      await logout();
      this.setState({ 
        loginMessage: "",
        hasShownLogoutToast: false  // Reset the flag on logout
      });
      // Dispatch the resetState action to clear the Redux state on logout
      this.props.resetState();
      // Hard reload to fetch fresh JS/CSS files from server
      window.location.reload(true);
      return "ok";
    } catch (error) {
      console.error('Error logging out:', error);
      // Still clear state even if logout API fails
      this.setState({ 
        loginMessage: "",
        hasShownLogoutToast: false  // Reset the flag on logout
      });
      this.props.resetState();
      return "error";
    }
  }

  render() {
    const { isRefreshing } = this.state;
    const creditHold = this.props?.Flag_CreditHold;
    return (
      <div id="App">
        <ToastContainer
          containerId={'A'}
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition:Bounce
        />
        <ToastContainer />

        {isRefreshing && (
          <div className="refresh-indicator">
            Refreshing data...
          </div>
        )}

        {creditHold ? <CreditHoldBanner /> : ""}

        <Header
          isLoggedIn={this.isLoggedIn()}
          account={this.props?.account}
          logout={this.appLogout}
          companyIds={this.props?.companyIds}
        />

        {!this.isLoggedIn() ? (
          <>
            <Login
              appFirstLogin={this.appFirstLogin}
              loginMessage={this.state.loginMessage}
            />
          </>
        ) : (
          <div>
            <Orders
              orders={this.props.orders}
              locations={this.props?.locations}
              getOrders={this.getOrders}
              getOrdersNew={this.getOrdersNew}
              clearOrders={this.clearOrders}
              userFullName={this.props?.account?.userFullName}
              deliveryPointDefault={this.props?.account?.deliveryPoint}
              carrierPref={this.props?.account?.carrierPref}
              exportOrders={this.exportOrders}
              peopleOnsite={this.props?.account?.peopleOnsite || []}
              viewOnly={this.props?.account?.viewOnly}
              canExport={this.props?.account?.canExport}
            />
          </div>
        )}
        <Footer />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);